import * as React from 'react';
import { translate, InjectedTranslatedProps } from 'react-i18next';
import { Button } from 'wix-ui-tpa/Button';
import { GroupList } from '../GroupList';
import CreateGroupModal from '../modals/CreateGroupModal/CreateGroupModal';
import Modal from '../modals/Modal';
import { ApiTypes } from '@wix/social-groups-api';
import {
  WithEditorSettings,
  WithEditorSettingsProps,
} from '@wix/editor-settings';

import withGroups, { WithGroupsProps } from '../../contexts/withGroups';
import withGroupsActions, {
  WithGroupsActionsProps,
} from '../../contexts/withGroupsActions';
import { text, display } from '../../settings';

import styles from './Groups.st.css';

export interface GroupsProps {
  isUserLoggedIn: boolean;
}

export interface GroupsState {
  isCreateGroupModalOpened: boolean;
  shouldCloseModal: boolean;
}

export type ComponentProps = InjectedTranslatedProps &
  GroupsProps &
  WithGroupsProps &
  WithGroupsActionsProps &
  WithEditorSettingsProps;

export class GroupsComponent extends React.Component<
  ComponentProps,
  GroupsState
> {
  readonly state: GroupsState = {
    isCreateGroupModalOpened: false,
    shouldCloseModal: false,
  };

  static getDerivedStateFromProps(props, state) {
    const { isGroupCreating } = props;
    const { isCreateGroupModalOpened, shouldCloseModal } = state;
    // close modal after group creation if needed
    if (isCreateGroupModalOpened) {
      if (isGroupCreating) {
        return { shouldCloseModal: true };
      }
      if (shouldCloseModal && isCreateGroupModalOpened && !isGroupCreating) {
        return { isCreateGroupModalOpened: false, shouldCloseModal: false };
      }
    }
    return null;
  }

  closeCreateGroupModal = () => {
    this.setState({ isCreateGroupModalOpened: false });
  };

  openCreateGroupModal = () => {
    if (this.props.isUserLoggedIn) {
      this.setState({ isCreateGroupModalOpened: true });
    } else {
      this.props.actions.promptLogin();
    }
  };

  onCreateGroup = (
    groupDetails: ApiTypes.v1.GroupDetails,
    settings: ApiTypes.v1.GroupSettings,
  ) => {
    this.props.actions.createGroup(groupDetails, settings);
  };

  render() {
    const { t, actions, settings } = this.props;
    const { isCreateGroupModalOpened } = this.state;
    return (
      <div className={styles.root} data-hook="groups">
        <div className={styles.header}>
          <div className={styles.title}>
            {settings.get(display.showHeaderTitle) && (
              <h2>{settings.get(text.groupListTitle)}</h2>
            )}
          </div>
          <Button
            data-hook="create-new-button"
            className={styles.mainButton}
            onClick={this.openCreateGroupModal}
          >
            {t('groups-web.btn.create-new')}
          </Button>
        </div>
        <GroupList
          onCreateGroupClick={this.openCreateGroupModal}
          goToGroup={actions ? actions.goToGroup : null}
        />
        <Modal
          isOpen={isCreateGroupModalOpened}
          onRequestClose={this.closeCreateGroupModal}
        >
          <CreateGroupModal
            data-hook="create-group-modal"
            onSubmit={this.onCreateGroup}
            onRequestClose={this.closeCreateGroupModal}
          />
        </Modal>
      </div>
    );
  }
}

export const Groups = withGroups(
  withGroupsActions(translate()(WithEditorSettings(GroupsComponent))),
) as React.ComponentType<GroupsProps>;
